module.exports = __webpack_public_path__ + "media/components/Cards/images/virtual-card-image-0711841b8959adc89a620b1d28b39720.png";